import React from "react";
import BasePage from "basecomponents/BasePage";

import { Route, Routes as Switch } from "react-router-dom";

// Components
import AdminSidebar from "layout/AdminSidebar";
import ClientTopBarMobile from "layout/ClientTopBarMobile";
import ClientTopBar from "layout/ClientTopBar";

// Paginas
import AdminDashboard from "innerpages/AdminDashboard";
import AdminDArticles from "innerpages/AdminDArticles";
import AdminDArticlesReception from "innerpages/AdminDArticlesReception";
import AdminDPackages from "innerpages/AdminDPackages";
import AdminDClients from "innerpages/AdminDClients";
import AdminDCalculator from "innerpages/AdminDCalculator";
import AdminDUsers from "innerpages/AdminDUsers";
import AdminDAccount from "innerpages/AdminDAccount";

import { initSidebarMenu } from "../utils/domUtils";

class AdminDashboardPage extends BasePage {
  componentDidMount(): void {
    setTimeout(() => {
      initSidebarMenu();
    }, 2000);
  }
  componentDidUpdate() {
    initSidebarMenu();
  }

  render() {
    return this.renderPage(
      <div id="containerbar">
        <AdminSidebar />

        <div className="rightbar">
          <ClientTopBarMobile />
          <ClientTopBar />

          <div className="contentbar">
            <div
              style={{
                marginTop: "4rem",
              }}
            >
              <Switch>
                <Route path="/" element={<AdminDashboard />} />

                {/* Paquetes */}
                <Route path="paquetes" element={<AdminDPackages />} />

                {/* Articulos */}
                <Route path="articulos" element={<AdminDArticles />} />
                <Route
                  path="articulos/recepcion"
                  element={<AdminDArticlesReception />}
                />

                {/* Clientes */}
                <Route path="clientes" element={<AdminDClients />} />

                {/* Herramientas */}
                <Route path="tools/calculator" element={<AdminDCalculator />} />

                {/* Usuarios */}
                <Route path="usuarios" element={<AdminDUsers />} />

                {/* Cuenta */}
                <Route path="account" element={<AdminDAccount />} />
              </Switch>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AdminDashboardPage;
